import { OnboardingPage3Actions } from './constants';

const initialState = {

};

function OnboardingPage3Reducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case OnboardingPage3Actions.START_LOADING:
      return { ...state, loading: true };
    case OnboardingPage3Actions.END_LOADING:
      return { ...state, loading: false };
    case OnboardingPage3Actions.SET_PROFILE_DATA: {
      return { ...state, ...payload };
    }
    case OnboardingPage3Actions.RESET_DATA: {
      return { ...initialState };
    }
    default:
      return state;
  }
}

export default OnboardingPage3Reducer;
